var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitetaCommitCheck1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1921 1081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{letter-spacing:-.01em;}.cls-2{letter-spacing:0em;}.cls-3{letter-spacing:0em;}.cls-4{stroke:#000;}.cls-4,.cls-5,.cls-6{stroke-miterlimit:10;}.cls-7,.cls-5,.cls-8{fill:#fff;}.cls-9{letter-spacing:0em;}.cls-10{letter-spacing:0em;}.cls-5,.cls-6,.cls-8{stroke:#fff;}.cls-6{fill:none;}.cls-8{font-family:MyriadPro-Regular, 'Myriad Pro';font-size:20px;}.cls-11{letter-spacing:0em;}.cls-12{letter-spacing:.01em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.5,
    y: 0.5,
    width: 1920,
    height: 1080
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 315.65,
    y: 643.52,
    width: 351,
    height: 168
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M666.15,644.02v167H316.15v-167h350m1-1H315.15v169h352v-169h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 1353.65,
    cy: 403.52,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1353.65,364.02c21.78,0,39.5,17.72,39.5,39.5s-17.72,39.5-39.5,39.5-39.5-17.72-39.5-39.5,17.72-39.5,39.5-39.5m0-1c-22.37,0-40.5,18.13-40.5,40.5s18.13,40.5,40.5,40.5,40.5-18.13,40.5-40.5-18.13-40.5-40.5-40.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 435.65,
    cy: 212.52,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M435.65,173.02c21.78,0,39.5,17.72,39.5,39.5s-17.72,39.5-39.5,39.5-39.5-17.72-39.5-39.5,17.72-39.5,39.5-39.5m0-1c-22.37,0-40.5,18.13-40.5,40.5s18.13,40.5,40.5,40.5,40.5-18.13,40.5-40.5-18.13-40.5-40.5-40.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 516.65,
    cy: 293.52,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M516.65,254.02c21.78,0,39.5,17.72,39.5,39.5s-17.72,39.5-39.5,39.5-39.5-17.72-39.5-39.5,17.72-39.5,39.5-39.5m0-1c-22.37,0-40.5,18.13-40.5,40.5s18.13,40.5,40.5,40.5,40.5-18.13,40.5-40.5-18.13-40.5-40.5-40.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 435.65,
    cy: 293.52,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M435.65,254.02c21.78,0,39.5,17.72,39.5,39.5s-17.72,39.5-39.5,39.5-39.5-17.72-39.5-39.5,17.72-39.5,39.5-39.5m0-1c-22.37,0-40.5,18.13-40.5,40.5s18.13,40.5,40.5,40.5,40.5-18.13,40.5-40.5-18.13-40.5-40.5-40.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 516.65,
    cy: 212.52,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M516.65,173.02c21.78,0,39.5,17.72,39.5,39.5s-17.72,39.5-39.5,39.5-39.5-17.72-39.5-39.5,17.72-39.5,39.5-39.5m0-1c-22.37,0-40.5,18.13-40.5,40.5s18.13,40.5,40.5,40.5,40.5-18.13,40.5-40.5-18.13-40.5-40.5-40.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 589.65,
    cy: 253.52,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M589.65,214.02c21.78,0,39.5,17.72,39.5,39.5s-17.72,39.5-39.5,39.5-39.5-17.72-39.5-39.5,17.72-39.5,39.5-39.5m0-1c-22.37,0-40.5,18.13-40.5,40.5s18.13,40.5,40.5,40.5,40.5-18.13,40.5-40.5-18.13-40.5-40.5-40.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 848.7,
    cy: 212.54,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M848.7,173.04c21.78,0,39.5,17.72,39.5,39.5s-17.72,39.5-39.5,39.5-39.5-17.72-39.5-39.5,17.72-39.5,39.5-39.5m0-1c-22.37,0-40.5,18.13-40.5,40.5s18.13,40.5,40.5,40.5,40.5-18.13,40.5-40.5-18.13-40.5-40.5-40.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 929.7,
    cy: 293.54,
    r: 40,
    transform: "translate(-41.56 378.12) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M929.7,254.04c21.78,0,39.5,17.72,39.5,39.5s-17.72,39.5-39.5,39.5-39.5-17.72-39.5-39.5,17.72-39.5,39.5-39.5m0-1c-22.37,0-40.5,18.13-40.5,40.5s18.13,40.5,40.5,40.5,40.5-18.13,40.5-40.5-18.13-40.5-40.5-40.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 808.65,
    cy: 339.52,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M808.65,300.02c21.78,0,39.5,17.72,39.5,39.5s-17.72,39.5-39.5,39.5-39.5-17.72-39.5-39.5,17.72-39.5,39.5-39.5m0-1c-22.37,0-40.5,18.13-40.5,40.5s18.13,40.5,40.5,40.5,40.5-18.13,40.5-40.5-18.13-40.5-40.5-40.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 929.7,
    cy: 212.54,
    r: 40,
    transform: "translate(-10.56 371.96) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M929.7,173.04c21.78,0,39.5,17.72,39.5,39.5s-17.72,39.5-39.5,39.5-39.5-17.72-39.5-39.5,17.72-39.5,39.5-39.5m0-1c-22.37,0-40.5,18.13-40.5,40.5s18.13,40.5,40.5,40.5,40.5-18.13,40.5-40.5-18.13-40.5-40.5-40.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 1002.7,
    cy: 253.54,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1002.7,214.04c21.78,0,39.5,17.72,39.5,39.5s-17.72,39.5-39.5,39.5-39.5-17.72-39.5-39.5,17.72-39.5,39.5-39.5m0-1c-22.37,0-40.5,18.13-40.5,40.5s18.13,40.5,40.5,40.5,40.5-18.13,40.5-40.5-18.13-40.5-40.5-40.5h0Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 630.15,
    y1: 253.52,
    x2: 918.15,
    y2: 253.52
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(408.21 218.53)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 0,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 8.84,
    y: 0
  }, "ommit")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(405.82 299.18)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "...")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(489.85 218.91)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "...")), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(490.77 294.25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "...")), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 808.65,
    y1: 379.52,
    x2: 835.65,
    y2: 435.52
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(814.29 459.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "change "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 66.24,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 75.66,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 85.68,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 94.9,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 101.4,
    y: 0
  }, "or")), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1281.17,
    y1: 262.18,
    x2: 1426.14,
    y2: 562.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1417.04,
    y1: 259.32,
    x2: 1282.36,
    y2: 564.75
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(1414.86 407.25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 11.38,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.72,
    y: 0
  }, "oblem "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 75.74,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.58,
    y: 0
  }, "ode")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 568.65,
    cy: 749.52,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M568.65,710.02c21.78,0,39.5,17.72,39.5,39.5s-17.72,39.5-39.5,39.5-39.5-17.72-39.5-39.5,17.72-39.5,39.5-39.5m0-1c-22.37,0-40.5,18.13-40.5,40.5s18.13,40.5,40.5,40.5,40.5-18.13,40.5-40.5-18.13-40.5-40.5-40.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 484.65,
    cy: 749.52,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M484.65,710.02c21.78,0,39.5,17.72,39.5,39.5s-17.72,39.5-39.5,39.5-39.5-17.72-39.5-39.5,17.72-39.5,39.5-39.5m0-1c-22.37,0-40.5,18.13-40.5,40.5s18.13,40.5,40.5,40.5,40.5-18.13,40.5-40.5-18.13-40.5-40.5-40.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 400.65,
    cy: 749.52,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M400.65,710.02c21.78,0,39.5,17.72,39.5,39.5s-17.72,39.5-39.5,39.5-39.5-17.72-39.5-39.5,17.72-39.5,39.5-39.5m0-1c-22.37,0-40.5,18.13-40.5,40.5s18.13,40.5,40.5,40.5,40.5-18.13,40.5-40.5-18.13-40.5-40.5-40.5h0Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(441.15 664.98)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.84,
    y: 0
  }, "epo")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 477.65,
    cy: 478.52,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M477.65,439.02c21.78,0,39.5,17.72,39.5,39.5s-17.72,39.5-39.5,39.5-39.5-17.72-39.5-39.5,17.72-39.5,39.5-39.5m0-1c-22.37,0-40.5,18.13-40.5,40.5s18.13,40.5,40.5,40.5,40.5-18.13,40.5-40.5-18.13-40.5-40.5-40.5h0Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 405.17,
    y1: 337.18,
    x2: 550.14,
    y2: 637.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 541.04,
    y1: 334.32,
    x2: 406.36,
    y2: 639.75
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(529.86 482.25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 8.96,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 15.3,
    y: 0
  }, "osschain "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 91.84,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 100.68,
    y: 0
  }, "onne"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 143.88,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 153.1,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 159.6,
    y: 0
  }, "or")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitetaCommitCheck1);
export default __webpack_public_path__ + "static/media/giteta-commit-check-1.0248977a24b6095947625116231313c7.svg";
export { ForwardRef as ReactComponent };